


















import { Component, Prop, Vue } from 'vue-property-decorator';
import AccommodationProjection from '../../../types/projections/AccommodationProjection';
import { ValidationError } from 'class-validator';
import i18next from 'i18next';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: { NewTranslation },
})
export default class BookingAccommodationDisplay extends Vue {
  @Prop({ type: Object, required: true })
  public accommodation!: AccommodationProjection;

  @Prop(Object)
  public validationError!: ValidationError | null;

  public get hasErrors(): boolean {
    return !!this.validationError;
  }

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }
}
